/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import TableDisplay from './TableDisplay'
import WordCloudDisplay from './WordCloudDisplay'
import DisplayOption from '../../../../enums/DisplayOption'
import { SocialWebWordCloudWidget as SocialWebWordCloudWidgetType } from '../../../../schemas/SocialWebWordCloudWidgetSchema'

const SocialWebWordCloudWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebWordCloudWidgetType>(widgetId)

  const { displayOption } = widgetSetting
  if (!displayOption || displayOption === DisplayOption.WORDCLOUD) {
    return <WordCloudDisplay widgetSetting={widgetSetting} widgetId={widgetId} />
  }

  if (displayOption === DisplayOption.TABLE) {
    return <TableDisplay widgetSetting={widgetSetting} widgetId={widgetId} />
  }

  throw new Error(`Unsupported display option: ${displayOption}`)
}
export default SocialWebWordCloudWidget
